export function issuanceCode(setCode) {
  const exCode = '12345' // 이메일 인증 번호
  setCode(exCode)
}
